import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
 import { Globals } from '../../globals';
import { PendingRequest } from '../modal/pendingrequest';
import { Approved, updateApproved } from '../modal/approved';
 import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';
import { DataService } from './data.service';
import { Attachment } from '../modal/approved';
@Injectable({
    providedIn: 'root'
})

export class UploadFileS3BucketService{
  
  constructor(private global:Globals,private data:DataService,private _httpClient: HttpClient,private uploadf:UploadFileS3BucketService) { }
  FOLDER ='';
 

  

  uploadfile(file,type){
   this.FOLDER = this.global.loggedUser.user.firstName +this.global.loggedUser.user.user_reg_id;
 debugger;
    const bucket = new S3(
      {
        accessKeyId: 'AKIA6K37OZAXNZNQEAAT',
        secretAccessKey: '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',
        region: 'ap-south-1'
      
      }
    );
 for(var i=0;i<file.length;i++){
 
  if(type=='profileImg'){
    const params = {
      Bucket: 'mdhl/'+this.global.loggedUser.user.user_reg_id,
      Key: "profileImg."+ file[i].type.split("/")[1],
      Body: file[i],
      ACL: 'public-read',
    };
    bucket.upload(params, function (err, data) {
      this.savefile=params.Body;
       if (err) {
         console.log('There was an error uploading your file: ', err);
         return false;
       }else{
         console.log('Successfully uploaded profile pic.', data);
         Globals.attachmentStatus=true;
         return true;
       }
     
     });



  }else{
    const params = {
      Bucket: 'mdhl/'+this.global.loggedUser.user.user_reg_id, 
      Key: file[i].name,
      Body: file[i],
      ACL: 'public-read',
    };

    bucket.upload(params, function (err, data) {
      this.savefile=params.Body;
       if (err) {
         console.log('There was an error uploading your file: ', err);
         return false;
       }else{
         console.log('Successfully uploaded file.', data);
         Globals.attachmentStatus=true;
         return true;
   
       }
     
     });



  }

 

  
 }
   
  
  }

  uploadCampRegisterUserProfileImg(file,userid){
  
  debugger;
     const bucket = new S3(
       {
         accessKeyId: 'AKIA6K37OZAXNZNQEAAT',
         secretAccessKey: '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',
         region: 'ap-south-1'
       
       }
     );
  for(var i=0;i<file.length;i++){
  
   
     const params = {
       Bucket: 'mdhl/'+userid,
       Key: "profileImg."+ file[i].type.split("/")[1],
       Body: file[i],
       ACL: 'public-read',
     };
     bucket.upload(params, function (err, data) {
       this.savefile=params.Body;
        if (err) {
          console.log('There was an error uploading your file: ', err);
          return false;
        }else{
          console.log('Successfully uploaded profile pic.', data);
          Globals.attachmentStatus=true;
          return true;
        }
      
      });
 
  }
    
   
   }




  // saveFiletoData(data,savefile){
  //   var s3path="https://s3.ap-south-1.amazonaws.com/sp-de-bucket/";
  //   var attchment=new Attachment();
  //   attchment.filePath=s3path+data.Bucket+"/"+data.Key;
   
  //   attchment.fileType=savefile.fileType;
  //   attchment.fileSize=savefile.size;
  //   attchment.user_id=this.global.loggedUser.user.user_reg_id;
  //   this.global.attachmentList.push(attchment);
  //   let headers:HttpHeaders=new HttpHeaders();
  //   headers=headers.append('Authorization', "Bearer " + this.global.loggedUser.token);
  //    this._httpClient.post(this.global.G_apiUrl +'/attachment',attchment,{headers:headers});



  // }
  
}